import {call, put, takeEvery} from 'redux-saga/effects'
import Api from '../services/Api'

function* fetchMobility() {
  try {
    const mobility = yield call(function() {
      return Api.get('/dealer/mobility');
    });
    yield put({type: 'FETCH_MOBILITY.SUCCESS', mobility})
  } catch (error) {
    yield put({type: 'FETCH_MOBILITY.FAILURE', error})
  }
}

function* saveMobility(action) {
  try {
    const mobility = yield call(function () {
      return Api.post('/dealer/mobility', action.body);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'});
    yield put({type: 'SAVE_MOBILITY.SUCCESS', mobility});
  } catch (error) {
    yield put({type: 'SAVE_MOBILITY.FAILURE', error})
  }
}

export function* watchFetchMobility() {
  yield takeEvery('FETCH_MOBILITY.REQUEST', fetchMobility);
}

export function* watchSaveMobility() {
  yield takeEvery('SAVE_MOBILITY.REQUEST', saveMobility)
}
